module.exports = __webpack_public_path__ + "img/ryketC9SgLgfKcK0c6L4o.18f11a0c.svg";